import * as is from '../utilities/is';
import { ANNOTATION_EVENT, PLAYER_EVENT, APPLICATION_EVENT } from 'constants/events';
import { visibleOrInTime } from './annotation_display_filters';
import { getStateLogger } from 'utilities/state';

// Filters annotation display to just "in time" and "visible" annotations
export class AnnotationEngine {
    constructor(options, eventBus) {
        this.lastHash = '';
        this.options = options;
        this.eventBus = eventBus;
        this.availableAnnotations = [];
        this.currentTime = this.defaultStartTime;

        this.eventBus.on(APPLICATION_EVENT.LOAD, this.onSetupLoaded.bind(this));
        this.eventBus.on(APPLICATION_EVENT.UPDATED, this.onSetupLoaded.bind(this));
        this.eventBus.on(PLAYER_EVENT.TIME_UPDATE, this.onTimeUpdate.bind(this));
    }

    onSetupLoaded(data) {
        this.availableAnnotations = data.annotations;
        this.broadcastAnnotationUpdates();
    }

    onTimeUpdate(event, player) {
        this.currentTime = player.currentTime;
        this.broadcastAnnotationUpdates();
    }

    broadcastAnnotationUpdates() {
        // safeguard to ensure rest of app has finished processing before sending update again
        // todo - figure out how to remove this in the future
        requestAnimationFrame(() => {
            const annotations = this.availableAnnotations.filter(visibleOrInTime.bind(this, this.currentTime));
            this.eventBus.emit(ANNOTATION_EVENT.ANNOTATIONS_UPDATED, annotations);
        })
    }

    get defaultStartTime() {
        return is.number(this.options.startTime) ? this.options.startTime : 0;
    }
}